import React, { FC } from 'react';
import { useTheme } from 'styled-components';

interface IData {
  topicResults: Array<{
    topic: {
      title: string;
    };
  }>;
}

interface IXAxisLabelBottom {
  data: IData[];
  positionedData: { topic: { title: string }; xPosition: number }[];
  width: number;
  isAgreementActive: boolean;
}

const XAxisLabelBottom: FC<IXAxisLabelBottom> = ({ positionedData, isAgreementActive }) => {
  const theme = useTheme();
  const labelOffset = 15;
  const bottomOffset = isAgreementActive ? 540 : 510;

  return (
    <g>
      {positionedData.map((entry, index) => {
        const x = entry.xPosition + labelOffset;

        return (
          <text
            key={`label-${index}`}
            x={x}
            y={bottomOffset}
            textAnchor="end"
            fontSize="14"
            fontWeight="500"
            fill={theme.colors.neutral.primary[40]}
            transform={`rotate(-45 ${x}, ${bottomOffset})`}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {entry.topic.title}
          </text>
        );
      })}
    </g>
  );
};

export default XAxisLabelBottom;
